import React, { useEffect, useState, useContext } from "react";
import { useParams, Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { getMovieDetail } from "../api/movieApi";
import Loading from "../components/Loading/Loading";
import "./../assets/styles/css/MovieDetailPage.css";
import { ThemeContext } from "../contexts/ThemeContext";

const MovieDetailPage = () => {
  const { slug } = useParams();
  const [movie, setMovie] = useState(null);
  const [episodes, setEpisodes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { isDarkMode } = useContext(ThemeContext);

  useEffect(() => {
    document.documentElement.setAttribute(
      "data-theme",
      isDarkMode ? "dark" : "light"
    );
  }, [isDarkMode]);

  useEffect(() => {
    const fetchMovieDetail = async () => {
      try {
        const response = await getMovieDetail(slug);

        if (response.data?.episodes) setEpisodes(response.data.episodes);
        if (response.data?.movie) setMovie(response.data.movie);
        else setError("Không tìm thấy thông tin phim.");
      } catch (error) {
        console.error("Lỗi khi gọi API chi tiết phim:", error);
        setError("Không thể tải chi tiết phim.");
      } finally {
        setLoading(false);
      }
    };

    fetchMovieDetail();
  }, [slug]);

  if (loading) return <Loading />;
  if (error) return <p className="error">{error}</p>;

  const hasValidEpisodes = episodes.some((server) =>
    server.server_data.some(
      (episode) =>
        episode.name &&
        episode.slug &&
        episode.link_m3u8 
    )
  );

  return (
    <div
      className="movie-detail-page"
      style={{
        backgroundImage: `url(${movie?.poster_url})`,
      }}
    >
      <Helmet>
        <title>{movie ? `${movie.name} - Xem phim cùng Zăn Hảo` : "Phim không tồn tại"}</title>
        <meta name="description" content={movie ? movie.content : "Không tìm thấy phim"} />
        <meta property="og:title" content={movie?.name || "Phim không tồn tại"} />
        <meta property="og:image" content={movie?.poster_url || "/logo-movie.svg"} />
        <meta property="og:description" content={movie?.content || "Xem phim online miễn phí"} />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="website" />
      </Helmet>

      {movie && (
        <div className="movie-info">
          <div className="movie-info-1">
            <img src={movie.poster_url} alt={movie.name} />
          </div>
          <div className="movie-info-2">
            <h1>{movie.name}</h1>
            <p>{movie.content}</p>
            <ul>
              <li>
                <strong>Loại:</strong> {movie.type}
              </li>
              <li>
                <strong>Chất lượng:</strong> {movie.quality}
              </li>
              <li>
                <strong>Ngôn ngữ:</strong> {movie.lang}
              </li>
              <li>
                <strong>Tổng số:</strong> {movie.episode_total} tập
              </li>
              <li>
                <strong>Diễn viên:</strong> {movie.actor.join(", ")}
              </li>
            </ul>
            <a
              href={movie.trailer_url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/default-placeholder.svg" alt="Trailer Thumbnail" />
              Xem trailer
            </a>
          </div>
        </div>
      )}
      {hasValidEpisodes && (
        <div className="episode-list">
          <h2>DANH SÁCH TẬP PHIM</h2>
          <ul>
            {episodes[0].server_data
              .filter(
                (episode) =>
                  episode.name &&
                  episode.slug &&
                  episode.link_m3u8 
              )
              .map((episode) => (
                <li key={episode.slug}>
                  <Link
                    to={`/phim/${movie.slug}/${episode.slug}`}
                    state={{
                      videoUrl: episode.link_m3u8,
                      TitleName: episode.filename,
                    }}
                  >
                    {episode.name}
                  </Link>
                </li>
              ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default MovieDetailPage;
